// extracted by mini-css-extract-plugin
module.exports = {"root":"AlertCounter_root__2hDl8"};